import { GetterTree } from 'vuex';
import { State } from './state';
import { RootState } from '@/store';
import { GET_PROFILE_LIST,
    GET_REGISTER_PROFILE_FORM_VISIBILITY,
    GET_SELECTED_PROFILE,
    GET_COUNTRY_LIST,
    GET_FLAG_LIST,
    GET_VEHICLE_TYPE_LIST,
    GET_CURRENT_PROFILE_TAB,
} from './types';

export const getters: GetterTree<State, RootState> = {
    [GET_PROFILE_LIST](state: State) {
        return state.profiles;
    },
    [GET_REGISTER_PROFILE_FORM_VISIBILITY](state: State) {
        return state.showRegisterForm;
    },
    [GET_SELECTED_PROFILE](state: State) {
        return state.profileSelected;
    },
    [GET_COUNTRY_LIST](state: State) {
        return state.countries;
    },
    [GET_FLAG_LIST](state: State) {
        return state.flags;
    },
    [GET_VEHICLE_TYPE_LIST](state: State) {
        return state.vehicleTypes;
    },
    [GET_CURRENT_PROFILE_TAB](state: State) {
        return state.currentTab;
    },
};
